import jwtDecode from "jwt-decode";

const tokenKey = "token";

export function clearStoredToken() {
  localStorage.removeItem(tokenKey);
}

export function storeToken(jwt) {
  localStorage.setItem(tokenKey, jwt);
}

export function getValidToken() {
  const jwt = localStorage.getItem(tokenKey);
  if (!jwt) return null;

  try {
    const decodedToken = jwtDecode(jwt);
    if (!decodedToken.exp || decodedToken.exp < Date.now() / 1000) {
      clearStoredToken();
      return null;
    }
    return jwt;
  } catch (ex) {
    clearStoredToken();
    return null;
  }
}

export function getCurrentUser() {
  const jwt = getValidToken();
  return jwt ? jwtDecode(jwt) : null;
}

export default { clearStoredToken, storeToken, getValidToken, getCurrentUser };
